import { ProductStatus } from 'gql/types';

export const productStatuses = Object.values(ProductStatus).map((value) => {
  return {
    value,
    label: value,
  };
});
